import {IInnovation} from 'app/models/project'
import {JsonObject} from 'utilities/types'
import {CGraphEntity} from './graph_entity'
import {CNote} from './note'

export class CInnovation extends CGraphEntity<IInnovation> implements IInnovation {
  static children = {
    notes: CNote,
  }

  abstract
  background
  overview
  title_link
  tech_description
  advantages
  applications
  publications
  ip_status
  track_code
  contact_info
  researcher_names
  categories
  downloads
  date_published_available
  stage
  references
  technological_validation
  t2
  business

  constructor(data: IInnovation & JsonObject) {
    super('Innovation', data)
    this.business = data.business
    this.t2 = data.t2
    this.technological_validation = data.technological_validation
    this.references = data.references
    this.stage = data.stage
    this.date_published_available = data.date_published_available
    this.contact_info = data.contact_info
    this.track_code = data.track_code
    this.ip_status = data.ip_status
    this.publications = data.publications
    this.applications = data.applications
    this.advantages = data.advantages
    this.tech_description = data.tech_description
    this.overview = data.overview
    this.background = data.background
    this.abstract = data.abstract
    this.title_link = data.title_link
    //arrays
    this.downloads = data.downloads
    this.categories = data.categories
    this.researcher_names = data.researcher_names
  }

  stringify() {
    return JSON.stringify(this.export())
  }

  export() {
    return {id: this.id}
  }
}
